import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import { CurrencyHelper } from "~/helpers/currency_helper";

// This controller is used to delete the selected leads lists.
export default class extends Controller {
  static get targets() {
    return ["modal", "text"]
  }

  static get values() {
    return {
      filters: { type: Object, default: {} },
      numberOfCompanyLists: { type: Number, default: 0 },
      selectedCompanyListIds: { type: Array, default: [] },
    }
  }

  connect() {
    if (this.hasTextTarget) {
      this.textTarget.innerText = i18n.t("js.back.company_lists_actions.delete_lists", {
        count: this.numberOfCompanyListsValue,
        company_lists: CurrencyHelper.numberWithDelimiter(this.numberOfCompanyListsValue)
      })
    }
  }

  // This action opens the modal to ask for confirmation before deleting the selected leads lists.
  show() {
    new bootstrap.Modal(this.modalTarget).show()
  }

  // This action submits a temporary form to delete the selected leads lists.
  submit(event) {
    event.target.disabled = true
    event.target.innerHTML = `<div class='far fa-spinner-third fa-spin'></div> ${i18n.t("js.back.company_lists_actions.deleting")}`

    TempFormHelper.create("/company-lists/bulk", "delete", (form) => {
      if (this.selectedCompanyListIdsValue.length > 0) {
        this.selectedCompanyListIdsValue.forEach(id => { TempFormHelper.addHiddenInput(form, "company_list_ids[]", id) })
      } else {
        Object.entries(this.filtersValue).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(item => {
              TempFormHelper.addHiddenInput(form, `${key}[]`, item)
            })
          } else {
            TempFormHelper.addHiddenInput(form, key, value)
          }
        })
      }
    }).requestSubmit()
  }

  // This action is used to update the selected leads lists value and update the text in the modal based on the number
  // of leads lists.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedCompanyListIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedCompanyListIdsValue = event.detail.dataSets.map(dataSet => dataSet.recordId).filter(Boolean)
    } else {
      this.selectedCompanyListIdsValue = []
    }

    const numberOfCompanyLists = event.detail.checked > 0 ? event.detail.checked : this.numberOfCompanyListsValue

    if (this.hasTextTarget) {
      this.textTarget.innerText = i18n.t("js.back.company_lists_actions.delete_lists", {
        count: numberOfCompanyLists,
        company_lists: CurrencyHelper.numberWithDelimiter(numberOfCompanyLists)
      })
    }
  }
}
